import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { MyDatePicker, SingleSelect } from "@westcut/lib-client-common";
import {
  addSingleDuration,
  humanReadableTime,
} from "@westcut/lib-common-tools";
import {
  useBlockCreateMutation,
  usePossibilitiesLazyQuery,
} from "../../Generated/graphql";
import { useData } from "../../Provider/Data";

interface Props {
  onClose: () => void;
  onSuccess: () => void;
}

export const Period: React.FC<Props> = ({ onClose, onSuccess }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { operator, operators } = useData();
  const [getOperatorId, setOperatorId] = React.useState<number>(operator.id);
  const [getDay, setDay] = React.useState<Date>(new Date());
  const [getStart, setStart] = React.useState<Date | undefined>();
  const [create, { loading }] = useBlockCreateMutation();

  const [
    loadData,
    { data, loading: LoadingPossibilities },
  ] = usePossibilitiesLazyQuery();

  React.useEffect(() => {
    loadData({ variables: { day: getDay, operatorId: getOperatorId } });
  }, [loadData, getDay, getOperatorId]);

  const slots =
    data?.possibilities.map((possibility) => new Date(possibility)) || [];

  const processCreate = () => {
    if (!getStart) {
      return;
    }
    create({
      variables: {
        input: {
          operatorId: getOperatorId,
          from: getStart,
          to: addSingleDuration(getStart),
        },
      },
      update: () => {
        onSuccess();
      },
    });
  };
  return (
    <Dialog fullScreen={fullScreen} open onClose={onClose} maxWidth="md">
      <DialogContent>
        <Typography color="textSecondary" variant="h4" gutterBottom>
          Poser une pause
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12}>
            <SingleSelect
              disableClearable
              currentValue={getOperatorId}
              label="Coiffeur"
              setNewValue={(value) => setOperatorId(value || operator.id)}
              options={operators.map(({ id, name }) => ({
                label: name,
                value: id,
              }))}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <MyDatePicker
              label="Jour"
              value={getDay}
              onChange={(value) => setDay(value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            {slots.length !== 0 ? (
              <SingleSelect
                disableClearable
                currentValue={getStart}
                label="Heure de début"
                setNewValue={(value) => setStart(value)}
                options={slots.map((slot) => ({
                  label: humanReadableTime(slot),
                  value: slot,
                }))}
              />
            ) : (
              <Typography color="textSecondary">
                {LoadingPossibilities
                  ? "Chargement"
                  : "Aucun horaire disponible pour ce jour"}
              </Typography>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Button onClick={onClose} color="secondary" disabled={loading}>
          Annuler
        </Button>
        <Button onClick={processCreate} color="primary" disabled={loading}>
          Confirmer
        </Button>
      </DialogActions>
    </Dialog>
  );
};
